export default {
  contact: {
    title: '@:contact_section.card_title',
    title_message: 'For non-registered users',
    description_1: 'Please contact the following with the name of the company that received the survey response request.',
    description_2: 'We will contact you within one business day.',
    contact_to_text: 'Contact information',
    copied_message: 'Email address copied.',
  },
}
